<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["authLogOut"]),
  },
  created() {
    this.authLogOut();
    this.$auth0.logout();
    window.localStorage.removeItem("vuex");
    this.$auth0.loginWithRedirect();
  },
};
</script>
